import type { TemplateId, ThemeId } from '@/types/portfolio';

export interface TemplateMeta {
  readonly id: TemplateId;
  readonly name: string;
  readonly subtitle: string;
  readonly description: string;
  readonly bestFor: ReadonlyArray<string>;
}

export const TEMPLATE_CATALOG: ReadonlyArray<TemplateMeta> = [
  {
    id: 'minimal',
    name: 'Minimal',
    subtitle: 'Editorial · Default',
    description: 'Generous whitespace, serif accents, and uncompromising typographic rigor.',
    bestFor: ['Writers', 'Strategists', 'Consultants'],
  },
  {
    id: 'dev-log',
    name: 'Dev log',
    subtitle: 'Monospace · Technical',
    description: 'Terminal-flavored monospace layout built around projects and commits.',
    bestFor: ['Engineers', 'Indie hackers'],
  },
  {
    id: 'compass',
    name: 'Compass',
    subtitle: 'Sidebar · Navigable',
    description: 'Sticky section rail with prev/next pagers — a calm, navigable shell for deep content.',
    bestFor: ['Engineers', 'PMs', 'Writers'],
  },
  {
    id: 'batman',
    name: 'Batman',
    subtitle: 'Noir · Night mode',
    description: 'Gotham-black canvas with bat-signal yellow. Dramatic, moody, high-contrast.',
    bestFor: ['Designers', 'Creatives', 'Night owls'],
  },
  {
    id: 'spiderman',
    name: 'Spider-Man',
    subtitle: 'Comic · Red + Blue',
    description: 'Web-slinging energy in classic red and navy. Bold, confident, friendly-neighborhood.',
    bestFor: ['Creators', 'Students', 'Portfolios with personality'],
  },
];

export interface ThemeMeta {
  readonly id: ThemeId;
  readonly name: string;
  readonly mood: string;
  readonly colors: readonly [string, string, string];
}

export const THEME_CATALOG: ReadonlyArray<ThemeMeta> = [
  {
    id: 'ink',
    name: 'Ink',
    mood: 'Default · Mono',
    colors: ['#FCFCFD', '#0F172A', '#475569'],
  },
  {
    id: 'paper',
    name: 'Paper',
    mood: 'Warm · Calm',
    colors: ['#FBF9F4', '#2A2520', '#8C7F6F'],
  },
  {
    id: 'cool',
    name: 'Cool',
    mood: 'Precise · Clinical',
    colors: ['#F4F7FA', '#0B1220', '#5A6B80'],
  },
  {
    id: 'warm',
    name: 'Warm',
    mood: 'Living · Human',
    colors: ['#FFF7F0', '#271A12', '#8B6A4A'],
  },
];

export function getTemplate(id: TemplateId): TemplateMeta {
  return TEMPLATE_CATALOG.find((t) => t.id === id) ?? TEMPLATE_CATALOG[0];
}
export function getTheme(id: ThemeId): ThemeMeta {
  return THEME_CATALOG.find((t) => t.id === id) ?? THEME_CATALOG[0];
}
